<template>
    <div class="value-table">
        <slot/>
    </div>
</template>

<script>
export default {
    name: 'value-table',
    components: {},
    props: {}
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

.value-table
    width: 100%
    display: block
    margin-bottom: -20px

    .value-table-row
        padding: 0px 10px 10px
        margin: 15px 0px 15px
        flex-grow: 1
        font-size: 16px
        border-bottom: 1px solid $border-color
        display: flex
        align-items: center
        justify-content: center

        *
            flex-grow: 1

        h5
            font-weight: bold
            margin: 0px
            padding: 0px

        span
            display: inline-block
            text-align: right

        &:last-child
            border-bottom-width: 0px

    @media screen and (max-width: 480px)
        display: block
</style>
